import { render, staticRenderFns } from "./userView.vue?vue&type=template&id=195cb262&scoped=true"
import script from "./userView.vue?vue&type=script&lang=js"
export * from "./userView.vue?vue&type=script&lang=js"
import style0 from "./userView.vue?vue&type=style&index=0&id=195cb262&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195cb262",
  null
  
)

export default component.exports